<template>
  <div class="home">
    <v-card max-width="500" class="mx-auto">
      <v-card>        
        <v-card-actions>
          <v-btn text color="blue-grey" @click="goHome">
              <v-icon>mdi-arrow-left</v-icon>
              <span class="ml-2">홈 가기</span>
          </v-btn>
          <v-spacer></v-spacer>

          <!-- component -->
          <!-- <Backup /> -->

          <!-- component -->
          <ProfileImage :user='user' />

          <!-- menu -->
          <v-menu bottom origin="center center" transition="scale-transition">
            <template v-slot:activator="{ on }">
              <v-btn class="ml-3" icon v-on="on"><v-icon>mdi-dots-vertical</v-icon></v-btn>
            </template>

            <v-list>
              <v-list-item @click="logout">
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <v-btn icon small>
                      <v-icon>mdi-logout</v-icon>
                    </v-btn>
                    <span class="ml-3">로그아웃</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item router to="/edit-profile">
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <v-btn icon small>
                      <v-icon>mdi-account</v-icon>
                    </v-btn>
                    <span class="ml-3">정보수정</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item router to="/farewell">
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <v-btn icon small>
                      <v-icon>mdi-logout-variant</v-icon>
                    </v-btn>
                    <span class="ml-3">앱 탈퇴</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-actions>

        <!-- graph -->
        <v-sheet
          v-if="(user.wins+user.loses) > 0"
          class="v-sheet--offset mx-auto"
          color="indigo lighten-1"
          elevation="0"
          max-width="calc(100%)"
        >
          <v-sparkline
            :labels="user.history"
            :value="user.history"
            stroke-linecap="round"
            color="white"
            type="trend"
            line-width="2"
            padding="16"
            height="150"
            auto-draw
          ></v-sparkline>
        </v-sheet>

        <!-- alternative image  -->
        <v-parallax v-else height="230" src="/cross.jpg"></v-parallax>

      </v-card>


      <v-list two-line>
        <v-subheader>내 정보</v-subheader>
        <v-list-item>
          <v-list-item-action></v-list-item-action>
          
          <v-list-item-content>
            <v-list-item-title v-text="user.name"></v-list-item-title>
            <v-list-item-subtitle v-text="user.alias"></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title v-text="user.type"></v-list-item-title>
            <v-list-item-subtitle>유형</v-list-item-subtitle>
          </v-list-item-content>
          
          <v-list-item-icon>
            <v-icon>mdi-table-tennis</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-divider inset></v-divider>
          
        <v-list-item>
          <v-list-item-action></v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ user.level }}부</v-list-item-title>
            <v-list-item-subtitle>
              <span v-for="n in user.level" :key="n">
                <v-icon small color="orange">mdi-star</v-icon>
              </span>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title class="indigo--text">{{ user.total }}</v-list-item-title>
            <v-list-item-subtitle>총점</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon>
            <!-- component -->
            <RatingChart />
          </v-list-item-icon>
        </v-list-item>
        <v-divider inset></v-divider>
 
        <v-list-item>
          <v-list-item-action></v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ user.wins }} 승 {{ user.loses }} 패</v-list-item-title>
            <v-list-item-subtitle>전체</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title>{{ user.wins }} 승 {{ user.loses }} 패</v-list-item-title>
            <v-list-item-subtitle>최근 3개월</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon>mdi-counter</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <v-divider></v-divider>

      </v-list>
      <v-list shaped>

        <!-- subheader  -->
        <v-subheader>공개 모임</v-subheader>

        <!-- open league -->
        <v-list-item-group v-model="mainGroup" color="blue-grey">
          <v-list-item @click="goToGroup('open-league')" v-if="openGroup[0]">
            <v-list-item-action></v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>오픈리그</v-list-item-title>
              <v-list-item-subtitle></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title><span class="blue-grey--text font-italic mr-1">{{ openGroup[0].members.length }}</span>명</v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar>
              <v-img :src="openGroup[0].imgURL"></v-img>
            </v-list-item-avatar>
          </v-list-item>

        <!-- subheader -->
        <v-subheader>지역 모임</v-subheader>
        <v-divider inset v-if="myGroups.length != 0"></v-divider>

        <!-- my groups -->
          <v-list-item @click="goToGroup(group.id)" v-for="group in myGroups" :key="group.id">
            <v-list-item-action></v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{ group.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ group.region }}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-content>
              <v-list-item-title><span class="blue-grey--text font-italic mr-1">{{ group.members.length }}</span>명</v-list-item-title>
            </v-list-item-content>

            <v-list-item-avatar>
              <v-img :src="group.imgURL"></v-img>
            </v-list-item-avatar>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-divider></v-divider>
      
      <v-card-actions>
        <!-- <v-btn @click="transport">temporary</v-btn> -->
        <v-spacer></v-spacer>
        <v-btn @click="goToGroups" text>
          <span class="mr-2">다른 모임 가기</span>
          <v-icon color="blue-grey">mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>      
    </v-card>
  </div>
</template>

<script>
import db from '@/fb'
import firebase from 'firebase/app'
import 'firebase/auth'
import ProfileImage from '@/components/ProfileImage'
import Backup from '@/components/Backup'
import RatingChart from '@/components/RatingChart'

export default {
  name: 'MyPage',
  components: { ProfileImage, Backup, RatingChart },
  data: () => ({
    groups: [],
    user: '',
    players: [],
    mainGroup: 0
  }),
  methods: {
    goToGroup(id){
      this.$router.push({ name: 'Games', params: { group_id: id} });
    },
    goToGroups() {
      this.$router.push({ name: 'Groups' })
    },
    goHome(){
      this.$router.push({ name: 'Home' })
    },
    containObject(members, alias){
      var i;
      for (i = 0; i < members.length; i++) {
        if (members[i]['alias'] == alias) {
            return true;
        }
      }
      return false;
    },
    logout(){
      firebase.auth().signOut().then(() => {
          this.$router.push({ name: 'Home' })
      })
    },
    farewell(){
      this.$router.push({ name: 'Farewell' })
    },
    // transport(){
    //   let members = this.openGroup[0].members
    //   this.myGroups.forEach(group => {
    //     group.members.forEach(member => {
    //       members.push(member)
    //     })
    //   })

    //   db.collection('groups').doc('open-league').update({
    //     members: members
    //   })
    // }
  },
  computed: {
    totalPoints(){
      return this.user.total / 20
    },
    myGroups(){
      // filtering others out
      return this.groups.filter(group => {
        return this.containObject(group.members, this.user.alias) && group.name != 'Open League'            
      })
    },
    openGroup(){
      return this.groups.filter(group => {
        return group.name == 'Open League'
      })
    }
  },
  created(){
    
    // get current user
    let user = firebase.auth().currentUser;

    // firebase.auth().languageCode = 'kr';
    // user.sendEmailVerification().then(function() {
    //   console.log('Email sent')
    // }).catch(function(error) {
    //   console.log(error.message)
    // });

    // find the user record
    if(user){
      db.collection('users').where('user_id', '==', user.uid).get()
        .then(snapshot => {
          snapshot.forEach(doc => {
              this.user = { ...doc.data(), id: doc.id };
          })
        }).then(() => {
          // fiind all the groups
          db.collection('groups').orderBy('timeStamp', 'desc').onSnapshot(snapshot => {
              let changes = snapshot.docChanges();
              changes.forEach(change => {          
                if(change.type == 'added'){
                    this.groups.unshift({
                        ...change.doc.data(),
                        id: change.doc.id
                    });
                } else if(change.type == 'removed'){
                  this.groups = this.groups.filter(group => {
                      return group.id != change.doc.id;
                  })
                }
              })
          })              
        }).then(() => {
          db.collection('users').onSnapshot(snapshot => {
            let changes = snapshot.docChanges();
            changes.forEach(change => {
              if(change.type == 'added'){
                this.players.unshift({
                  ...change.doc.data(),
                  id: change.doc.id
                });
              } else if(change.type == 'removed'){
                this.players = this.players.filter(player => {
                    return player.id != change.doc.id;
                })
              }
            })
          })
        })
    } else {
        return false
    }
  }
};
</script>


 